import { Trans, useTranslation } from "react-i18next";
import { useMemo } from "react";

import { ActionButtons } from "../Common/ActionButtons";
import { AttributeItem } from "./AttributeItem";
import { Container, Heading, LeftSide, RightSide, Section } from "../Common";
import { GameKind } from "../../../../../../gql/graphql";
import { GamePreview } from "../../GamePreview";
import { isTriviaGame } from "../../../../../../graphql/helpers/isTriviaGame";
import { TriviaAdvancedSettings } from "./TriviaAdvancedSettings";
import { useGame } from "../../../../../../contexts/game/GameContext";

import styles from "./AdvancedSettings.module.scss";

export const AdvancedSettings = () => {
  const { t } = useTranslation();
  const { currentAttributes, currentGame } = useGame();

  const isWordopolis = useMemo(() => currentGame?.kind === GameKind.Wordopolis, [currentGame?.kind]);
  const isWordle = useMemo(() => currentGame?.kind === GameKind.Wordle, [currentGame?.kind]);

  if (currentGame && isTriviaGame(currentGame)) {
    return <TriviaAdvancedSettings />;
  }

  let description = t("project:advancedSettings.description");

  switch (currentGame?.kind) {
    case GameKind.Wordopolis:
      description = t("project:advancedSettings.wordopolisDescription");
      break;
    case GameKind.Wordle:
      description = t("project:advancedSettings.wordleDescription");
      break;
  }

  const editorText = isWordopolis
    ? t("project:advancedSettings.form.wordopolisEditor")
    : t("project:advancedSettings.form.editor");

  return (
    <Container>
      <RightSide>
        <GamePreview />
      </RightSide>
      <LeftSide>
        <Heading title={{ main: t("project:advancedSettings.header1"), marked: t("project:advancedSettings.header2") }}>
          <Trans i18nKey={description} />
        </Heading>

        {!isWordle && (
          <Section title={editorText}>
            <div className={styles.attributes}>
              {currentAttributes.map((attribute) => (
                <AttributeItem
                  key={attribute.id}
                  attribute={attribute}
                  isWordopolis={isWordopolis}
                  game={currentGame}
                />
              ))}
            </div>
          </Section>
        )}

        <ActionButtons />
      </LeftSide>
    </Container>
  );
};
